// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"baa1360c","690":"79bf3f75","696":"cf9ed207","787":"3ce4cc4d","992":"e86598a3"}[chunkId] + ".chunk.js";
};